import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LuMail } from 'react-icons/lu';

import { MainRoutes } from 'helpers/routes';
import { useAnnouncements } from 'context/AnnouncementsContext';

type Props = {
  className?: string;
};

const AnnouncementBanner: React.FC<Props> = ({ className = '' }) => {
  const navigate = useNavigate();
  const { latestMessage } = useAnnouncements();

  if (!latestMessage) {
    return null;
  }

  const handleClick = () => {
    navigate(MainRoutes.UPDATES);
  };

  return (
    <button
      type="button"
      className={`announcement-banner ${className}`.trim()}
      onClick={handleClick}
      aria-label={`Read message: ${latestMessage.title}`}
    >
      <LuMail className="announcement-banner__icon" aria-hidden />
      <span className="announcement-banner__title">{latestMessage.title}</span>
      <span className="announcement-banner__link">View more</span>
    </button>
  );
};

export default AnnouncementBanner;
